import { render } from "./recouvrementParAcitive.vue?vue&type=template&id=784a4868"
import script from "./recouvrementParAcitive.vue?vue&type=script&lang=js"
export * from "./recouvrementParAcitive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__